
import { Page } from "modules/Page";
import { initAnchorNavigation } from "modules/AnchorNavigation";

export class ServicePage extends Page<typeof ServicePage> {
    public static readonly className = "js-service-page";

    constructor(rootElement: HTMLElement, index: number) {
        super(rootElement, index);

        initAnchorNavigation(".js-service-page");
    }
}